export const getComposerCategory = (state) => state.otherData.composerCategory;
